import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment-timezone';
import i18nify from '@wix/restaurants-components/dist/shared/I18nify';
import styles from './ModifyReservationMobile.scss';
import classNames from 'classnames';
import ReservationDetails from '@wix/wix-restaurants-renderer-js/dist/Reservations/ReservationDetails';
import ReservationContactInfoVertical from '@wix/wix-restaurants-renderer-js/dist/Reservations/ReservationContactInfoVertical';
import ContactMapDetails from '@wix/wix-restaurants-renderer-js/dist/Reservations/ContactMapDetails';
import ReservationCancellationReason from '@wix/wix-restaurants-renderer-js/dist/Reservations/ReservationCancellationReason';
import {Link} from 'react-router';
import {openrestHelpers, GoogleMapsUtils} from '@wix/wixrest-utils';
import PoweredBy from '../PoweredBy/PoweredBy';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import reservationUtils from '../../utils/reservationUtils';
import staticMap from '../StaticMap/StaticMap';

export class Reservation extends React.Component {
  render() {
    const {reservation, organization, i18n, isNewlyCanceled} = this.props;
    const displayableReservation = openrestHelpers.Reservation.getDisplayableReservation(reservation, organization, moment);
    const isCancelable = reservation.status === 'new' || reservation.status === 'accepted';
    /* eslint-disable no-template-curly-in-string */
    const status = i18n.get('modify_reservation_status_' + displayableReservation.displayStatus, displayableReservation.displayStatus);
    const direction = i18n.isRtlDir() ? 'rtl' : 'ltr';
    const title = reservationUtils.getTitle(i18n, displayableReservation.displayStatus);
    const subTitle = reservationUtils.getSubTitle(i18n, displayableReservation.displayStatus);
    const StaticMap = staticMap();
    const home = reservationUtils.generateHomeHref(this.props);
    const isAccepted = reservation.status === 'accepted';
    const address = organization.address.formatted;
    const latLng = organization.address.latLng;
    const addressLink = GoogleMapsUtils.buildLocalizedGoogleMapsUrl(i18n, {ie: 'UTF8', ll: `${latLng.lat},${latLng.lng}`, q: address});

    const modifyReservation = (
      <div className={styles.reservation} style={{direction}}>
        <div className={classNames(styles.title, styles[`statusColor${reservation.status}`])}>{title}</div>
        <div className={styles.subTitle}>{subTitle}</div>

        <div className={styles.innerWrapper}>


          <div className={classNames(styles.innerHeader)}>
            <div className={styles.metaData}>
              <span id="orderNumber">{i18n.get('reservations_email_restaurant_reservationinfo_reservationid', 'Reservation #${params.id}', {
                params: {id: reservation.id}
              })}</span> |
              {' '} {i18n.get('modify_reservation_received', 'Received')} {displayableReservation.received}
            </div>
            <div className={classNames(styles.metaData, styles.metaDataBottom)}>
              <span>{i18n.get('modify_reservation_status', 'Reservation status')} </span>
              <span className={classNames(styles.status, styles[`statusColor${reservation.status}`])}>{status}</span>
            </div>
          </div>
          <div className={styles.divider}/>

          <ReservationCancellationReason
            fontFamily="HelveticaNeueW01-45Ligh"
            reservation={reservation}
            i18n={i18n}
            paddingVertical={24}
            paddingHorizontal={24}
            />

          <div className={classNames(styles.box, styles.reservationDetailsBox)}>
            <ReservationDetails
              titleFontFamily="HelveticaNeueW01-65Medi"
              fontFamily='"HelveticaNeueW01-45Ligh", "HelveticaNeueW02-45Ligh", "HelveticaNeueW10-45Ligh", "Helvetica Neue", "Helvetica", "Arial", "メイリオ", "meiryo", "ヒラギノ角ゴ pro w3", "hiragino kaku gothic pro"'
              reservation={reservation}
              restaurant={organization}
              detailsTextColor={'#20455e'}
              titlePaddingBottom={10}
              paddingBottom={32}
              paddingInlineEnd={0}
              i18n={i18n}
              />
          </div>

          <div className={classNames(styles.box, styles.contactInfoBox)}>
            <ReservationContactInfoVertical
              fontFamily="HelveticaNeueW01-45Ligh"
              reservation={reservation}
              restaurant={organization}
              detailsTextColor={'#20455e'}
              i18n={i18n}
              nameMaxWidth={180}
              />
          </div>

          <StaticMap
            organization={organization}
            width={0}
            height={160}
            displayLanguage="en"
            allowPointerEvents
            zoom={16}
            order={{}}
            />

          <div className={styles.box}>
            <ContactMapDetails
              address={displayableReservation.restaurantAddress}
              name={displayableReservation.restaurantTitle}
              phone={displayableReservation.restaurantPhone}
              i18n={i18n}
              fontFamily="HelveticaNeueW01-45Ligh"
              nameFontSize={20}
              countryCode={organization.address.countryCode}
              addressLink={addressLink}
              />
          </div>

          <div className={styles.contactMapDetails}>

            <div className={styles.divider}/>
            { isCancelable && <div className={classNames(styles.innerFooter, styles.row, styles.rowSpaceBetween)}>
              { isAccepted && <Link
                to={reservationUtils.generateAddToCalendarHref(this.props)}
                className={classNames(styles.action, styles.actionAddToCalendar)}
                >
                {i18n.get('modify_reservation_add_to_calendar', 'Add To Calendar')}
              </Link> }
              { isAccepted && <div className={styles.divider}/> }
              <Link
                to={reservationUtils.generateCancelReservationHref(this.props)}
                className={classNames(styles.action, styles.actionCancelReservation)}
                id="cancelButton"
                >
                {i18n.get('modify_reservation_cancel_reservation', 'Cancel Reservation')}
              </Link>
              <div className={styles.divider}/>
            </div> }
          </div>
        </div>

        <div className={styles.poweredBy}>
          <PoweredBy i18n={i18n}/>
        </div>

        <ReactCSSTransitionGroup
          component="div"
          transitionName="slideAnimation-up"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
          >
          {(isCancelable || isNewlyCanceled) && this.props.children && React.cloneElement(this.props.children, {home})}
        </ReactCSSTransitionGroup>

      </div>
    );

    return modifyReservation;
  }
}

Reservation.propTypes = {
  reservation: PropTypes.shape({
    id: PropTypes.string,
    partySize: PropTypes.number,
    customerStatus: PropTypes.string,
    restaurantStatus: PropTypes.string,
    status: PropTypes.string,
    ownerToken: PropTypes.string,
    locale: PropTypes.string,
    contact: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      phone: PropTypes.string
    }),
    timeGuarantee: PropTypes.string,
    time: PropTypes.number,
    heldUntil: PropTypes.number
  }),
  setReservationStatusRequest: PropTypes.func,
  organization: PropTypes.object,
  i18n: PropTypes.object,
  children: PropTypes.element,
  isNewlyCanceled: PropTypes.bool
};

export default i18nify(Reservation);



// WEBPACK FOOTER //
// ./components/ModifyReservationMobile/ModifyReservationMobile.js